// src/brand/all-eat-nh/theme.ts
export interface BrandTheme {
    name: string;
    displayName: string;
    tagline: string;
    description: string;
    companyName: string;
    copyright: string;
    contact: {
        representative: string;
        businessNumber: string;
        phone: string;
    };
    links: {
        kakaoOpenChat?: string;
        kakaoSupport?: string;
        directions?: string;
    };
    config: {
        apiBase: string;
        kakaoJsKey: string;
        redirectUri: string;
        gaKey: string;
        imgUrl: string;
        hideTagline?: boolean;
        reservationDeadline: string;
        cancellationDeadline: string;
        pickupDeadline: string;
    };
    colors: {
        primary: {
            50: string;
            100: string;
            200: string;
            300: string;
            400: string;
            500: string;
            600: string;
            700: string;
            800: string;
            900: string;
            950: string;
        };
    };
    metadata: {
        title: string;
        description: string;
        ogTitle: string;
        ogDescription: string;
        themeColor: string;
        manifestName: string;
        manifestFullName: string;
    };
}

export const theme: BrandTheme = {
    name: 'all-eat-nh',
    displayName: '올잇마켓 논현점',
    tagline: '🛒올잇마켓 - 신선한 먹거리🛒',
    description: '신선하고 품질 좋은 먹거리를\n합리적인 가격으로 만나보세요',
    companyName: '올잇마켓 논현점',
    copyright: '© 2025 올잇마켓 논현점',
    contact: {
        representative: '최승호',
        businessNumber: '010-7770-8671',
        phone: '010-7770-8671',
    },
    links: {
        kakaoOpenChat: 'https://open.kakao.com/o/example',
        kakaoSupport: 'https://open.kakao.com/o/example',
        directions: 'https://naver.me/example',
    },
    config: {
        apiBase: process.env.REACT_APP_API_BASE || '',
        kakaoJsKey: process.env.REACT_APP_JS_KAKAO_KEY || '',
        redirectUri: process.env.REACT_APP_REDIRECT_URI || '',
        gaKey: process.env.REACT_APP_GA_KEY || '',
        imgUrl: process.env.REACT_APP_IMG_URL || 'https://all-eat-nh.com',
        hideTagline: false,
        reservationDeadline: '19:30',
        cancellationDeadline: '19:00',
        pickupDeadline: '20:00',
    },
    colors: {
        primary: {
            50: '#fef2f2',
            100: '#fee2e2',
            200: '#fecaca',
            300: '#fca5a5',
            400: '#f87171',
            500: '#ef4444',
            600: '#dc2626',
            700: '#b91c1c',
            800: '#991b1b',
            900: '#7f1d1d',
            950: '#450a0a',
        },
    },
    metadata: {
        title: '올잇마켓(논현점)',
        description: '🛒올잇마켓(논현점) - 신선한 먹거리🛒 신선하고 품질 좋은 먹거리를 합리적인 가격으로!',
        ogTitle: '올잇마켓(논현점)',
        ogDescription: '신선하고 품질 좋은 먹거리를 합리적인 가격으로 만나보세요.',
        themeColor: '#ef4444',
        manifestName: '올잇마켓',
        manifestFullName: '올잇마켓 논현점',
    },
};

// CSS Variables mapping for runtime injection
export const cssVariables: Record<string, string> = {
    '--color-primary-50': theme.colors.primary[50],
    '--color-primary-100': theme.colors.primary[100],
    '--color-primary-200': theme.colors.primary[200],
    '--color-primary-300': theme.colors.primary[300],
    '--color-primary-400': theme.colors.primary[400],
    '--color-primary-500': theme.colors.primary[500],
    '--color-primary-600': theme.colors.primary[600],
    '--color-primary-700': theme.colors.primary[700],
    '--color-primary-800': theme.colors.primary[800],
    '--color-primary-900': theme.colors.primary[900],
    '--color-primary-950': theme.colors.primary[950],
};
